import { render, staticRenderFns } from "./DeviceAssignmentModal.vue?vue&type=template&id=06442956&scoped=true"
import script from "./DeviceAssignmentModal.vue?vue&type=script&lang=js"
export * from "./DeviceAssignmentModal.vue?vue&type=script&lang=js"
import style0 from "./DeviceAssignmentModal.vue?vue&type=style&index=0&id=06442956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06442956",
  null
  
)

export default component.exports